const conversionFactors = {
  'Watts': 1,
  'Kilowatts': 1000,
  'Megawatts': 1e6,
  'Gigawatts': 1e9,
  'Horsepower (Mechanical)': 745.699872,
  'Horsepower (Metric)': 735.49875,
  'BTU/hour': 0.29307107,
  'Foot-pounds/minute': 0.0225969658,
  'Calories/second': 4.1868,
  'Joules/second': 1,
  'Ergs/second': 1e-7,
  'Dyne-centimeters/second': 1e-7,
  'Newton-meters/second': 1,
  'Kilogram-meters/second': 9.80665,
  'Volt-amperes': 1,
};

export const convertPower = (value, fromUnit, toUnit) => {
  if (fromUnit === 'Decibel-milliwatts' || toUnit === 'Decibel-milliwatts') {
    return convertDbm(value, fromUnit, toUnit);
  }

  const wattsValue = value * conversionFactors[fromUnit];
  const result = wattsValue / conversionFactors[toUnit];
  
  return Number(result.toPrecision(10));
};

const convertDbm = (value, fromUnit, toUnit) => {
  if (fromUnit === 'Decibel-milliwatts' && toUnit === 'Watts') {
    return Math.pow(10, (value - 30) / 10);
  } else if (fromUnit === 'Watts' && toUnit === 'Decibel-milliwatts') {
    return 10 * Math.log10(value * 1000);
  } else if (fromUnit === 'Decibel-milliwatts') {
    const watts = Math.pow(10, (value - 30) / 10);
    return convertPower(watts, 'Watts', toUnit);
  } else if (toUnit === 'Decibel-milliwatts') {
    const watts = convertPower(value, fromUnit, 'Watts');
    return 10 * Math.log10(watts * 1000);
  }
};
